<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col cols="12">
          <v-progress-linear v-if="loading" indeterminate />
        </v-col>

        <v-col cols="12" md="6">
          <v-card-text>
            <div class="rowinfo">
              <price-input
                v-model="computedMinOrderCart"
                class="rounded-lg contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('min_order_cart')"
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-min_order_cart`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('min_order_cart')"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model="computedPreparationTime"
                class="rounded-lg contentinfo justify-center text-center centered-input"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('preparation_time')"
                outlined
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-preparation_time`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('preparation_time')"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model="computedDeliveryTime"
                class="rounded-lg contentinfo centered-input text-center"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('delivery_time')"
                outlined
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-delivery_time`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('delivery_time')"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model.number="computedValue.max_product_in_order"
                class="rounded-lg contentinfo centered-input text-center"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('max_product_in_order')"
                outlined
                type="text"
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-max_product_in_order`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('max_product_in_order')"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model.number="computedValue.max_order_by_person"
                class="rounded-lg contentinfo centered-input text-center"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('max_order_by_person')"
                outlined
                type="text"
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-max_order_by_person`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('max_order_by_person')"
              />
            </div>
            <div class="rowinfo" v-show="!!computedValue.send_by_courier">
              <price-input
                v-model="computedSendByCourierPrice"
                class="rounded-lg contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('send_by_courier_price')"
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-send_by_courier`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('send_by_courier_price')"
              />
            </div>
            <div class="rowinfo" v-show="vat">
              <v-text-field
                v-model="computedVat"
                class="rounded-lg contentinfo centered-input text-center"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('vat')"
                outlined
                type="text"
                :rules="vatRules"
                :append-icon="'mdi-percent'"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-vat`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('vat')"
              />
            </div>
            <div class="rowinfo" v-show="!!computedValue.send_by_post">
              <price-input
                v-model="computedSendByPost"
                class="rounded-lg contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :label="$t('send_by_post')"
                :rules="positiveNumberRules"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedValue-send_by_post`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('send_by_post')"
              />
            </div>
          </v-card-text>
        </v-col>

        <v-col cols="12" md="6">
          <v-card-text class="py-0">
            <v-switch
              v-model="computedValue.online_pay"
              dense
              inset
              :label="$t('online_pay')"
              @change="onChange($event, 'online_pay')"
            />
            <v-switch
              v-model="computedValue.pay_in_person_place"
              dense
              inset
              :label="$t('pay_in_person_place')"
              @change="onChange($event, 'pay_in_person_place')"
            />
              <v-switch
              v-model="computedValue.card_pay"
              dense
              inset
              :label="$t('qrOrdersList.paymentType.card2card')"
              @change="onChange($event, 'card_pay')"
            />
            <v-switch
              v-model="computedValue.in_place"
              dense
              inset
              :label="$t('in_place')"
              @change="onChange($event, 'in_place')"
            />
            <v-switch
              v-if="
                !computedValue.fieldFilters.includes('table_booking_ability')
              "
              v-model="computedValue.table_booking_ability"
              dense
              inset
              :label="$t('table_booking_ability')"
              @change="onChange($event, 'table_booking_ability')"
            />
            <v-switch
              v-model="computedValue.send_by_courier"
              dense
              inset
              :label="$t('send_by_courier')"
              @change="onChange($event, 'send_by_courier')"
            />
            <v-switch
              v-model="computedValue.send_by_post"
              dense
              inset
              :label="$t('send_by_post')"
              @change="onChange($event, 'send_by_post', 450000)"
            />
            <v-switch
              v-model="vat"
              dense
              inset
              :label="$t('vat_switch')"
              @change="(e) => (computedValue.vat = !!e ? 10 : null)"
            />
          </v-card-text>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState } from "vuex";
import PriceInput from "@/view/pages/uiBeautifier/priceInput.vue";

export default {
  name: "manageCart",
  components: { PriceInput },

  props: {
    value: {
      type: Object,
      default: () => ({
        min_order_cart: 0,
        preparation_time: 0,
        delivery_time: 0,
        max_product_in_order: 0,
        max_order_by_person: 0,
        send_by_courier: false,
        send_by_courier_price: 0,
        send_by_post: false,
        vat: null,
        online_pay: false,
        pay_in_person_place: false,
        card_pay:false,
        in_place: false,
        table_booking_ability: false,
      }),
      validator: (value) => {
        return (
          typeof value === "object" &&
          value !== null &&
          ["min_order_cart", "send_by_courier_price", "send_by_post"].every(
            (key) =>
              value[key] === undefined ||
              value[key] === null ||
              typeof value[key] === "number" ||
              typeof value[key] === "string"
          )
        );
      },
    },
    fieldFilters: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "manage-redirectQr",
    vat: false,
    send_by_post: false,
    loading: false,
  }),

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    computedValue: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedMinOrderCart: {
      get() {
        const value = this.computedValue.min_order_cart ?? 0;
        return this.use_lang(this.price(value));
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        this.$set(
          this.computedValue,
          "min_order_cart",
          parseFloat(cleanedValue) || 0
        );
      },
    },
    computedPreparationTime: {
      get() {
        const value = this.computedValue.preparation_time ?? 0;
        return this.use_lang(value.toString());
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        this.$set(
          this.computedValue,
          "preparation_time",
          parseFloat(cleanedValue) || 0
        );
      },
    },
    computedDeliveryTime: {
      get() {
        const value = this.computedValue.delivery_time ?? 0;
        return this.use_lang(value.toString());
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        this.$set(
          this.computedValue,
          "delivery_time",
          parseFloat(cleanedValue) || 0
        );
      },
    },
    computedSendByCourierPrice: {
      get() {
        const value = this.computedValue.send_by_courier_price ?? 0;
        return this.use_lang(this.price(value));
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        this.$set(
          this.computedValue,
          "send_by_courier_price",
          parseFloat(cleanedValue) || 0
        );
      },
    },
    computedSendByPost: {
      get() {
        const value = this.computedValue.send_by_post ?? 0;
        return this.use_lang(this.price(value));
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        this.$set(
          this.computedValue,
          "send_by_post",
          parseFloat(cleanedValue) || 0
        );
      },
    },
    computedVat: {
      get() {
        const value = this.computedValue.vat ?? 0;
        return this.use_lang(value.toString());
      },
      set(value) {
        const stringValue = (value || 0).toString();
        const cleanedValue = this.english(stringValue.replace(/,/g, ""));
        const numericValue = parseFloat(cleanedValue) || 0;
        this.$set(this.computedValue, "vat", numericValue);
      },
    },
    positiveNumberRules() {
      return [
        (v) => {
          const stringValue = String(v ?? "");
          return (
            /^[۰-۹٠-٩0-9,]+$/.test(stringValue) || this.$t("invalid_number")
          );
        },
        (v) => {
          const stringValue = String(v ?? "");
          const cleanedValue = this.english(stringValue.replace(/,/g, ""));
          const numericValue = parseFloat(cleanedValue) || 0;
          return numericValue >= 0 || this.$t("positive_number");
        },
      ];
    },
    vatRules() {
      return [
        (v) => {
          const stringValue = String(v ?? "");
          return (
            /^[۰-۹٠-٩0-9,]+$/.test(stringValue) || this.$t("invalid_number")
          );
        },
        (v) => {
          const stringValue = String(v ?? "");
          const cleanedValue = this.english(stringValue.replace(/,/g, ""));
          const numericValue = parseFloat(cleanedValue) || 0;
          return (
            (numericValue >= 0 && numericValue <= 100) || this.$t("vat_range")
          );
        },
      ];
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onChange(state, field, defaultValue = 1) {
      this.computedValue[field] = !!state ? defaultValue : 0;

      const _this = this;
      let pay = ["pay_in_person_place", "online_pay","card_pay"];
      let ship = [
        "in_place",
        "table_booking_ability",
        "send_by_courier",
        "send_by_post",
      ];

      this.value.fieldFilters.forEach((item) => {
        let index = ship.indexOf(item);
        if (index >= 0) ship.splice(index, 1);
      });

      check(pay.includes(field) ? pay : ship);

      function check(arr) {
        if (arr.includes(field)) {
          let f = arr.map((item) => !!_this.computedValue[item]);
          if (!_this.computedValue[field] && f.every((e) => !e)) {
            let index = arr.findIndex((item) => item === field);
            arr.splice(index, 1);
            _this.computedValue[arr[0]] = 1;
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center !important;
}
</style>
